import { Component } from '@angular/core';
import {
  NavigationEnd,
  RouteConfigLoadEnd,
  RouteConfigLoadStart,
  Router,
  RouterOutlet,
} from '@angular/router';
import { SpinnerService } from './common/spinner/spinner.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ModuleLoaderComponent } from './common/module-loader/module-loader.component';
import { getAppForUrl, setAppToRouteTo } from './common/app-constants';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [ModuleLoaderComponent, RouterOutlet],
})
export class AppComponent {
  title = 'My Personal Tracker';
  showSpinner = false;
  destroyed$ = new Subject<void>();
  currentScreenSize = '';

  constructor(
    private router: Router,
    public spinnerService: SpinnerService,
  ) {
    // loader logic + remember the last-visited mini-app
    this.router.events.pipe(takeUntil(this.destroyed$)).subscribe((event) => {
      if (event instanceof RouteConfigLoadStart) {
        this.showSpinner = true;
      } else if (event instanceof RouteConfigLoadEnd) {
        this.showSpinner = false;
      } else if (event instanceof NavigationEnd) {
        // Record whichever mini-app this navigation landed on (ignoring
        // login/register/profile/etc.) so the next login returns the user to
        // the app they were last in — not always the default.
        const app = getAppForUrl(event.urlAfterRedirects || event.url);
        if (app) setAppToRouteTo(app);
      }
    });
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
